import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import http from './api/http.js'
import api from './api/api.js';
import common from './common/common.js';
import mainHead from './components/mainHead.vue';
// Vue.prototype.BASE_URL = "http://192.168.1.17:30010/sylas"; //接口地址
Vue.prototype.BASE_URL = "https://sdk.richmob.cn/prod-api/sylas"; //接口地址
// Vue.prototype.BASE_URL = "http://sdktest.richmob.cn/prod-api/sylas"; //接口地址
// Vue.prototype.BASE_URL = "http://sdkapi.richmob.cn/sylas"; //接口地址
import "@/assets/font/font.css";
import directive from './directive' // directive
Vue.component('mainHead', mainHead);


//引入ElementUI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// import Userinfo from '@/components/Informationpopup/userinfo';
// Vue.prototype.$userinfo = Userinfo.install;


// import Productinfo from '@/components/Informationpopup/productinfo';
// Vue.prototype.$productinfo = Productinfo.install;
Vue.use(ElementUI)
// 引入重写的resetMessage.js文件
import { myMessage } from './common/resetMessage.js'
// 注意：挂载自定义$message必须放在Vue.use(ElementUI)后面，才能覆盖element-ui默认的message，不然没有效果
Vue.prototype.$message = myMessage;

// 转盘抽奖vue3引入
// import VueLuckyCanvas from '@lucky-canvas/vue'

//api接口表全局挂载
Vue.prototype.$api = api;
//接口请求全局注册
Vue.prototype.$http = http
Vue.prototype.$common = common
Vue.use(directive)

Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')